if (!customElements.get('linked-card-swatches')) {
  class LinkedCardSwatches extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const card = this.closest('.product-card');
      if (!card) return;

      const mainImg = card.querySelector('.product-card__image--main img');
      const wrapper = card.querySelector('.product-card__wrapper');
      if (!mainImg || !wrapper) return;

      this.mainImg = mainImg;
      this.wrapper = wrapper;
      this.defaultSrc = mainImg.getAttribute('src');
      this.defaultSrcset = mainImg.getAttribute('srcset');
      // Preview that persists after a click; null falls back to the card default.
      this.selectedSrc = null;
      this.selectedSrcset = null;

      const swatches = this.querySelectorAll('.product-card__linked-swatch:not(.product-card__linked-swatch--more)');
      swatches.forEach((swatch) => {
        const src = swatch.dataset.linkedPreviewSrc;
        const srcset = swatch.dataset.linkedPreviewSrcset;

        // Clicking/tapping previews the color in place and stays on the PLP.
        // Hover does not change the card image (per client request).
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          this.selectedSrc = src || null;
          this.selectedSrcset = srcset || null;
          this.setImage(this.selectedSrc, this.selectedSrcset);
          this.setCurrent(swatch);
        });
      });
    }

    setImage(src, srcset) {
      if (src) {
        this.wrapper.classList.add('is-previewing-swatch');
        if (srcset) {
          this.mainImg.setAttribute('srcset', srcset);
        } else {
          this.mainImg.removeAttribute('srcset');
        }
        this.mainImg.setAttribute('src', src);
        return;
      }

      // No preview selected: restore the card's default image.
      this.wrapper.classList.remove('is-previewing-swatch');
      if (this.defaultSrcset) {
        this.mainImg.setAttribute('srcset', this.defaultSrcset);
      } else {
        this.mainImg.removeAttribute('srcset');
      }
      if (this.defaultSrc) {
        this.mainImg.setAttribute('src', this.defaultSrc);
      }
    }

    setCurrent(swatch) {
      this.querySelectorAll('.product-card__linked-swatch.is-current').forEach((el) => el.classList.remove('is-current'));
      swatch.classList.add('is-current');
    }
  }

  customElements.define('linked-card-swatches', LinkedCardSwatches);
}
